<template>
  <div class="head">
    <div class="line"></div>
    <el-menu v-if="customHeader" :router="isRouter" :default-active="refreshPage !== '/' ? refreshPage:'/Homepage'"
             class="el-menu-demo" mode="horizontal" @select="handleSelect"
             :style="`background: url(${customHeader.logo});`">
      <el-menu-item v-if="customHeader.home" index="/Homepage">首页</el-menu-item>
      <el-menu-item v-if="customHeader.support" index="/Support">功能列表</el-menu-item>
      <el-submenu v-if="customHeader.doc" index="sha-x...hahaha">
        <template slot="title">开发者文档</template>
        <el-menu-item v-for="(item, index) in filterMenuList" :key="setHeadMenuIndex(index)"
                      :index="item.index" @click="setActiveMenuNew(item)">{{item.name}}</el-menu-item>
        <el-menu-item v-if="customHeader.tools" index="/DebuggingTools">调试工具</el-menu-item>
      </el-submenu>
      <el-menu-item v-if="customHeader.help" index="/Help">帮助中心</el-menu-item>
    </el-menu>
    <el-menu v-else :router="isRouter" :default-active="refreshPage !== '/' ? refreshPage:'/Homepage'" 
             class="el-menu-demo" mode="horizontal" @select="handleSelect">
      <el-menu-item index="/Homepage">首页</el-menu-item>
      <el-menu-item index="/Support">功能列表</el-menu-item>
      <el-submenu index="sha-x...hahaha">
        <template slot="title">开发者文档</template>
        <el-menu-item v-for="(item, index) in filterMenuList" :key="setHeadMenuIndex(index)"
                      :index="item.index" @click="setActiveMenuNew(item)">{{item.name}}</el-menu-item>
        <el-menu-item index="/DebuggingTools">调试工具</el-menu-item>
      </el-submenu>
      <el-menu-item index="/Help">帮助中心</el-menu-item>
    </el-menu>
  </div>
</template>

<script>
  import {mapState, mapMutations} from "vuex";

  export default {
    data() {
      return {
        isRouter: true,
        currentMenu: '',
        customHeader: '',
      };
    },
    created() {
      if (this.$root.customConfig.header && Object.keys(this.$root.customConfig.header).length > 0) {
        this.customHeader = this.$root.customConfig.header;
      }
    },
    computed: {
      ...mapState(["refreshPage", "menuList"]),
      filterMenuList() {
        let menuList = this.menuList
        return menuList.filter((item) => {
          return !item.hidden
        });
      }
    },
    mounted() {
      this.refreshFunction();
    },
    methods: {
      ...mapMutations([
        "setSelectName", //将 `this.setSelectName(amount)` 映射为 `this.$store.commit('setSelectName', amount)`
        "setRefreshPage"
      ]),
      handleSelect(key, keyPath) {
        window.sessionStorage.setItem("refreshPage", key);
      },
      refreshFunction() {
        let url = window.location.href;
        if (this.currentMenu === '') {
          url = url.split("://")[1]
          this.currentMenu = url.split("/")[1];
        }
        this.setRefreshPage(this.currentMenu.startsWith('/') ? this.currentMenu : '/' + this.currentMenu);
      },
      setActiveMenuNew(item) {
        this.setSelectName(item.active)
        this.currentMenu = item.index
      },
      setHeadMenuIndex(index) {
        return new Date().getTime() + '' + index
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  @import "../assets/less/var.less";

  .head {
    .el-menu-demo {
      padding-right: 10%;
      display: flex;
      justify-content: flex-end;
      border-bottom: 2.2px solid #ddd;
      background: url(../assets/images/jjk.png);
      background-repeat: no-repeat !important;
      /* background-size: 195px 36px; */
      background-position: 10% 50% !important;
      background-color: white !important;
      .el-menu-item {
        height: @height;
        line-height: @height;
      }
    }
  }

  .el-menu--horizontal .el-submenu .el-submenu__title {
    height: @height;
    line-height: @height;
  }

  .a_new {
    text-decoration: none;
    width: 100px;
    height: 50px;
    &:hover {
      text-decoration: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Head.vue